module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-&-Webprofits-Video-2.a0e978da.webp";